import { CONFIG_KEYS, getClientConfigBool } from '../shared/config'
import IndexPage from './pages'
import CentrePage from './pages/centre'
import BasicCentrePage from './pages/centre/basic-centre-page'
import DoncasterMaitreD from './pages/doncaster-maitre-d'
import PromotionalPage from './pages/promotional-page'
import FreeWifi from './pages/free-wifi'
import ErrorPage from './pages/error'
import TermsAndConditions from './pages/terms-and-conditions'
import PrivacyPage from './pages/privacy'
import ContentPage from './pages/content-page'
import Products from './pages/products'
import Buy from './pages/products/buy'
import {
  CENTRE,
  TERMS_AND_CONDITIONS,
  PRIVACY_POLICY,
  GIFT_CARDS,
} from './paths'

const NEXT_PUBLIC_FEAT_FLAG_GIFT_CARD_LANDING = getClientConfigBool(
  CONFIG_KEYS.NEXT_PUBLIC_FEAT_FLAG_GIFT_CARD_LANDING
)

const routes = [
  {
    path: `/_basic/:${CENTRE}`,
    component: BasicCentrePage,
  },
  {
    path: TERMS_AND_CONDITIONS,
    component: NEXT_PUBLIC_FEAT_FLAG_GIFT_CARD_LANDING
      ? ContentPage
      : TermsAndConditions,
  },
  {
    path: PRIVACY_POLICY,
    component: NEXT_PUBLIC_FEAT_FLAG_GIFT_CARD_LANDING
      ? ContentPage
      : PrivacyPage,
  },
  {
    path: '/products/buy/:id',
    component: Buy,
  },
  {
    path: '/products',
    component: Products,
  },
  {
    path: GIFT_CARDS,
    component: NEXT_PUBLIC_FEAT_FLAG_GIFT_CARD_LANDING
      ? PromotionalPage
      : ErrorPage,
  },
  {
    path: '/doncaster-maitre-d',
    component: DoncasterMaitreD,
  },
  {
    path: `/:${CENTRE}/free-wifi`,
    component: FreeWifi,
  },
  {
    path: `/:${CENTRE}`,
    component: CentrePage,
  },
  {
    path: '/',
    component: IndexPage,
  },
  {
    component: ErrorPage,
  },
]

export default routes
